export default __webpack_public_path__ + "static/media/m2.19ddef32.jpg";